export default "__VITE_ASSET__Ddbimxmo__"